import axios from 'axios'

const publishUrl = 'https://api.netlify.com/build_hooks/5b14ab66dd6a546b4057d6da'

export const publish = () => {
  axios.post(publishUrl, {})
  .then(function (res) {
    if (res.status === 200) {
      alert('Changes published. Updates should be live soon.')
    } else {
      alert('Something went wrong. Please try again, and if it doesn\'t work properly fire your developer.')
    }
  })
  .catch(function (error) {
    alert('Looks like there\'s a problem...')
    console.log(error)
  })
}


// WEBPACK FOOTER //
// /opt/build/repo/src/webhooks.js